import { jsx as _jsx } from "@emotion/react/jsx-runtime";
import { ColorPaper } from '@/components/ui/Surface/ColorPaper';
import { Text } from '@/components/ui/Typography/Body/Text';
/**
 * クライアント：ファイル共有時の注意事項
 * @param props
 * @constructor
 */
export const RfpClientOneFileAlert = (props) => {
    const { className = '' } = props;
    return (_jsx(ColorPaper, Object.assign({ bgColor: 'emphasis', className: className }, { children: _jsx(Text, Object.assign({ color: 'base', size: 'sm' }, { children: "\u4E00\u5EA6\u8CC7\u6599\u3092\u5171\u6709\u9802\u304F\u3068\u53D6\u308A\u6D88\u3059\u3053\u3068\u304C\u51FA\u6765\u306A\u3044\u305F\u3081\u3001\u3054\u6CE8\u610F\u304F\u3060\u3055\u3044\u3002 \u3082\u3057\u8CC7\u6599\u306E\u5DEE\u3057\u66FF\u3048\u3092\u5E0C\u671B\u3059\u308B\u65B9\u306F\u3001\u62C5\u5F53\u8005\u307E\u305F\u306F\u30B5\u30DD\u30FC\u30C8\u30C1\u30FC\u30E0\u307E\u3067\u3054\u9023\u7D61\u304F\u3060\u3055\u3044\u3002" })) })));
};
